<ion-grid>
  <ion-row>
    <ion-col class="use-number">
      Use your number on file: {{phone}} <span class="link" (click)="goToEditPhone()">Edit</span>
    </ion-col>
  </ion-row>
  <p *ngIf="offlineErr" class="tidy-alert">Please try again. You need a connection to update your phone number</p>
</ion-grid>
